import React from "react";
import { Link } from "react-router-dom";
import styles from "../AuthWrapper.module.css";

export default function AuthFooter() {
  return (
    <footer className={styles.authFooter}>
      <div className={styles.footerLinks}>
        <Link to="/terms-of-service" className={styles.footerLink}>
          Terms of Service
        </Link>
        <span className={styles.footerSeparator}>|</span>
        <Link to="/privacy-policy" className={styles.footerLink}>
          Privacy
        </Link>
        <span className={styles.footerSeparator}>|</span>
        <Link to="/compliance-statement" className={styles.footerLink}>
          18 U.S.C. 2257
        </Link>
        <span className={styles.footerSeparator}>|</span>
        <Link to="/DMCA-takedown-policy" className={styles.footerLink}>
          DMCA
        </Link>
        <span className={styles.footerSeparator}>|</span>
        <Link to="/acceptable-use-policy" className={styles.footerLink}>
          Acceptable Use
        </Link>
        <span className={styles.footerSeparator}>|</span>
        <Link to="/cookie-policy" className={styles.footerLink}>
          Cookie Policy
        </Link>
        <span className={styles.footerSeparator}>|</span>
        <a
          href="https://x.com/sugarcribs"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.footerLink}
        >
          X
        </a>
      </div>
    </footer>
  );
}

